module.exports = __webpack_public_path__ + "fonts/IRANSansWeb(FaNum).8271055.woff";